module.exports = __webpack_public_path__ + "img/porcentagem.fcebc4a1.svg";